import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1"
import Buy2 from "./component/buy2";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";




function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");
const[x5,setx5]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0x1f4bb39a2859c25be6884f6990aacf1506d448f3";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0xE2767A23D4f40C7F832F1E5C8010C4cCF0D6bB4C";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
     
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
      var i = 0;
           document.querySelector("#us").value  = alltasks[13];
      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[0]);
      sea1(a1);
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const x4 = Number(alltasks[22])/1000000000000000000;
     setx4(x4);
      const b =Number(alltasks[2]);
      const x5 = alltasks[13];
     setx5(x5);

     document.querySelector("#hid").value  = (alltasks[1]);
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);




     setB(b);

     

     const dd = Number(alltasks[9]);
          
     setDD(dd);

     const reward1 = Number(alltasks[11])/1000000000000000000;
          
     setreward1(reward1);
     
     const reward2 = Number(alltasks[17])/1000000000000000000;
          
     setreward2(reward2);
     const reward3 = Number(alltasks[18])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	
								
	
      const reward4 =  Number(alltasks[28]);
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);




      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);

      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);


     const x1 = Number(alltasks[18])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[21])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[22])/1000000000000000000;
     setx3(x3);
     
      
       document.querySelector("#tt2").value = tt2;
       
       const b1 = Number(alltasks[5]) ;
       setb1(b1);
       const b2 = Number(alltasks[6]) ;
       setb2(b2);
       const b3 = Number(alltasks[7]) ;
       setb3(b3);
       const b4 = Number(alltasks[8]) ;
       setb4(b4);
       const b5 = Number(alltasks[9]) ;
       setb5(b5);
       const b6 = Number(alltasks[10]) ;
       setb6(b6);
       const b7 = Number(alltasks[11]) ;
       setb7(b7);
       const b8 = Number(alltasks[12]) ;
       setb8(b8);
       const b9 = Number(alltasks[13])/1000000000000000000 ;
       setb9(b9);
       const b10 = Number(alltasks[14])/1000000000000000000 ;
       setb10(b10);

	   const b11 = Number(alltasks[34])/1000000000000000000 ;
       setb11(b11);
     const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const level1 = Number(alltasks[24]);
          
 setLevel1(level1);
 

     document.querySelector("#wi1").value =  Number(alltasks[15])/1000000000000000000;
     document.querySelector("#roi").value =  Number(alltasks[3]);
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
    // const a3 = Number(alltasks1[2])/1000000000000000000;
          
   //  sea3(a3);
     const a2 = Number(alltasks[24]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const pack1 = Number(alltasks[25])/1000000000000000000;

setpackage1(pack1);

const tt =  Number(alltasks[16])/1000000000000000000;
     settt(tt);
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://bvtpro.online/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);


console.log(pack);

  const dd2 = Number(alltasks[31]?.toString?.() || alltasks[30]);
setDD2(dd2);

const dd1 = Math.floor(Date.now() / 1000);
setDD1(dd1);

// remaining seconds (24 hours)
const totalSeconds = Math.max(0, 2592000 - (dd1 - dd2));

// convert to hh:mm:ss
const hours = Math.floor(totalSeconds / 3600);
const minutes = Math.floor((totalSeconds % 3600) / 60);
const seconds = totalSeconds % 60;

const formattedTime =
  String(hours).padStart(2, "0") + ":" +
  String(minutes).padStart(2, "0") + ":" +
  String(seconds).padStart(2, "0");

settt2(formattedTime);
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }
	document.body.style.backgroundColor = 'black';
  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
    <section className="trading-income-section" id="trading-dashboard">
  <div className="container">

    <div className="dashboard-header-block">
      <div className="section-tag">
        <span className="section-tag-icon"></span>
        BORDERLESS DECENTRALIZED ECONOMY
      </div>

      <h2 className="dashboard-main-title">
        
      Dashboard Overview
      </h2>
    </div>

    <div className="trade-income-grid">
    

      {/* CARD 1: INSTANT PURCHASE & TRADE ACTION BOX */}
      <div className="light-glass-box">
        <div className="trade-card-header">
          <div className="trade-card-title">
            <span className="card-icon-badge">⚡</span>
           Dashboard
          </div>

          
        </div>

        <div className="trade-action-body">

          {/* Purchase Action Row */}
          <div className="trade-input-block">
            <label className="trade-input-label">
             Purchase Using BVTPRO COIN
            </label>

            <div className="trade-input-wrapper">
             <input
                 type="text"
                 id ="amt"
                 className="trade-text-input"
                  placeholder="USDT"
                 />

             <p> <Buy state={state} /></p>
            </div>
          </div>

          {/* Trade / Swap Action Row */}
          <div className="trade-input-block">
            <label className="trade-input-label">
              Purchase Using USDT
            </label>

            <div className="trade-input-wrapper">
              <input
                 type="text"
                 id ="amt1"
                  className="trade-text-input"
                  placeholder="USDT"
                 
                  
                />
             <p> <Buy4 state={state} /></p>

             
            </div>
          </div>
            {/* Purchase Action Row */}
          <div className="trade-input-block">
            <label className="trade-input-label">
             Withdraw
            </label>

            <div className="trade-input-wrapper">
               <input
                  type="text"
                  id ="test"
                   className="trade-text-input"
                  placeholder="USDT"
                  
                  
                />
             

             <p> <Buy3 state={state}  /></p>
            </div>
          </div>

          {/* Trade / Swap Action Row */}
        {/* Withdraw + Reinvest - Same Row */}
<div className="withdraw-reinvest-row">

  <div className="withdraw-reinvest-row">

  {/* Withdraw Funds */}
  <div className="trade-input-block">
    <label className="trade-input-label">
      Withdraw Funds
    </label>

    <div className="trade-input-wrapper">
      <p>
        <Buy1 state={state} />
      </p>
    </div>
  </div>

  {/* Reinvest Funds */}
  <div className="trade-input-block">
    <label className="trade-input-label">
      Reinvest Funds
    </label>

    <div className="trade-input-wrapper">
      <p>
        <Buy5 state={state} />
      </p>
    </div>
  </div>
  <div className="trade-input-block">
    <label className="trade-input-label">
      Trade
    </label>

    <div className="trade-input-wrapper">
      <p>
        <Buy2 state={state} />
      </p>
    </div>
  </div>
  
</div>
        </div>
       <p> Next Trade In : {tt2} </p>
      </div>
</div>

       {/* CARD 3: LIVE MARKET TRADING TICKERS */}
      <div className="light-glass-box">

        <div className="trade-card-header">
          <div className="trade-card-title">
            <span className="card-icon-badge">📈</span>
           Teams
          </div>

         
        </div>

        <div className="tickers-list">

          {/* BVT */}
            {/* BVT */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">
              <span
                className="coin-symbol-badge"
                style={{ color: "var(--pink-primary)" }}
              >
                🌐
              </span>

              <span className="coin-name">
               Direct Team
              </span>
            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
              {direct}
              </span>

             
            </div>
          </div>


          {/* BITCOIN */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#f7931a" }}
              >
                ₿
              </span>

              <span className="coin-name">
                Level Team
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
              {level}
              </span>

             
            </div>
          </div>


          {/* ETHEREUM */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#627eea" }}
              >
                ⬡
              </span>

              <span className="coin-name">
               Team Business
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
                {level1}
              </span>

           
            </div>
          </div>
            {/* BVT */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">
              <span
                className="coin-symbol-badge"
                style={{ color: "var(--pink-primary)" }}
              >
               ⛓️
              </span>

              <span className="coin-name">
               Total Team
              </span>
            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
              {level + direct}
              </span>

             
            </div>
          </div>




         
</div>
</div>


      {/* CARD 3: LIVE MARKET TRADING TICKERS */}
      <div className="light-glass-box">

        <div className="trade-card-header">
          <div className="trade-card-title">
            <span className="card-icon-badge">📈</span>
            Current Week
          </div>

        
        </div>

        <div className="tickers-list">

          {/* BVT */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">
              <span
                className="coin-symbol-badge"
                style={{ color: "var(--pink-primary)" }}
              >
                🔒
              </span>

              <span className="coin-name">
               Current Week Direct Team
              </span>
            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
              {reward4}
              </span>

              
            </div>
          </div>


          {/* BITCOIN */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#f7931a" }}
              >
                ₿
              </span>

              <span className="coin-name">
              Current Week Team
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
                 {reward5}
              </span>

             
            </div>
          </div>


       

        </div>
      </div>
  {/* CARD 3: LIVE MARKET TRADING TICKERS */}
      <div className="light-glass-box">

        <div className="trade-card-header">
          <div className="trade-card-title">
            <span className="card-icon-badge">📈</span>
          Level Business
          </div>

         
        </div>

        <div className="tickers-list">

          {/* BVT */}
            {/* BVT */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">
              <span
                className="coin-symbol-badge"
                style={{ color: "var(--pink-primary)" }}
              >
                🌐
              </span>

              <span className="coin-name">
               Level 1 Business
              </span>
            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
              {b1}
              </span>

             
            </div>
          </div>


          {/* BITCOIN */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#f7931a" }}
              >
                ₿
              </span>

              <span className="coin-name">
                 Level 2 Business 
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
             {b2}
              </span>

             
            </div>
          </div>


          {/* ETHEREUM */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#627eea" }}
              >
                ⬡
              </span>

              <span className="coin-name">
               Level 3 Business
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
                 {b3}
              </span>

           
            </div>
          </div>

          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#627eea" }}
              >
                ⬡
              </span>

              <span className="coin-name">
               Level 4 Business
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
                 {b4}
              </span>

           
            </div>
          </div>

          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#627eea" }}
              >
                ⬡
              </span>

              <span className="coin-name">
               Level 5 Business
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
                 {b5}
              </span>

           
            </div>
          </div>
         
</div>
</div>


      {/* CARD 3: LIVE MARKET TRADING TICKERS */}
      <div className="light-glass-box">

        <div className="trade-card-header">
          <div className="trade-card-title">
            <span className="card-icon-badge">📈</span>
          My Package
          </div>

        
        </div>

        <div className="tickers-list">

          {/* BVT */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">
              <span
                className="coin-symbol-badge"
                style={{ color: "var(--pink-primary)" }}
              >
                🔒
              </span>

              <span className="coin-name">
              My Package
              </span>
            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
              {pack} USDT  
              </span>

              
            </div>
          </div>


          {/* BITCOIN */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#f7931a" }}
              >
                ₿
              </span>

              <span className="coin-name">
              My Fund value 
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
                 {pack1} 
              </span>

             
            </div>
          </div>
            {/* BITCOIN */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#f7931a" }}
              >
              🚀
              </span>

              <span className="coin-name">
             TOTAL WITHDRAWL
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
                {wlevel1} 
              </span>

             
            </div>
          </div>
</div></div>

      {/* CARD 4: QUANTUM TRADING BOT VAULT */}
      <div className="light-glass-box">

        <div className="trade-card-header">

          <div className="trade-card-title">
            <span className="card-icon-badge">🏛️</span>
            Income
          </div>

         

        </div>

        <div className="vault-info-body">


        <div className="ticker-item-row">
            <div className="ticker-coin-info">
              <span
                className="coin-symbol-badge"
                style={{ color: "var(--pink-primary)" }}
              >
                🌐
              </span>

              <span className="coin-name">
             TOTAL INCOME
              </span>
            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
             {tt + wlevel1}
              </span>

             
            </div>
          </div>


          {/* BITCOIN */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#f7931a" }}
              >
                ₿
              </span>

              <span className="coin-name">
               Level Income
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
             {x4}
              </span>

             
            </div>
          </div>


          {/* ETHEREUM */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">

              <span
                className="coin-symbol-badge"
                style={{ color: "#627eea" }}
              >
                ⬡
              </span>

              <span className="coin-name">
              Single Leg Income 
              </span>

            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
               {x1}
              </span>

           
            </div>
          </div>
            {/* BVT */}
          <div className="ticker-item-row">
            <div className="ticker-coin-info">
              <span
                className="coin-symbol-badge"
                style={{ color: "var(--pink-primary)" }}
              >
               ⛓️
              </span>

              <span className="coin-name">
              Salary 
              </span>
            </div>

            <div className="ticker-price-info">
              <span className="coin-price">
             0
              </span>

             
            </div>
          </div>

 
          
        </div>
      </div>
{/* REFERRAL LINK BOX */}
<div className="light-glass-box referral-box">

  <div className="trade-card-header">
    <div className="trade-card-title">
      <span className="card-icon-badge">🔗</span>
      REFERRAL LINK
    </div>

    <span className="live-status-pill">
      SHARE
    </span>
  </div>

  <div className="referral-content">

    <label className="trade-input-label">
      YOUR REFERRAL LINK
    </label>

    <div className="referral-link-wrapper">

      <input
        type="text"
        className="trade-text-input"
        value={referlink}
        readOnly
      />

      <button
        type="button"
        className="btn-action-pink"
        onClick={() => {
          navigator.clipboard.writeText(referlink);
        }}
      >
        COPY ↗
      </button>

    </div>

  </div>

</div>
{/* REFERRAL CARD */}
<div className="light-glass-box referral-card">

  {/* Header */}
  <div className="trade-card-header">
    <div className="trade-card-title">
      <span className="card-icon-badge">🔗</span>
      MY REFERRALS
    </div>

    <span className="live-status-pill">
      ACTIVE
    </span>
  </div>


  {/* Referral Icon */}
  <div className="referral-icon-area">
    <div className="referral-dao-icon">

     
    </div>
  </div>


  {/* Referral Count */}
  <div className="referral-info">

    <span className="trade-input-label">
      MY REFERRALS
    </span>

    <div className="account-address">
      {refer}
    </div>

  </div>

</div>
{/* MY ACCOUNT CARD */}
<div className="light-glass-box account-card">

  {/* Header */}
  <div className="trade-card-header">

    <div className="trade-card-title">
      <span className="card-icon-badge">👤</span>
      MY ACCOUNT
    </div>

    <span className="live-status-pill">
      CONNECTED
    </span>

  </div>



  {/* Account Details */}
  <div className="account-details">

    <div className="account-label">
      WALLET ADDRESS
    </div>

    <div className="account-address">
      {account}
    </div>

  </div>


 
</div>
    </div>
  </div>
</section>


 
</div>  
  );
}

export default App;